export default "<p>\n  missing-page works!\n</p>\n"